import React from 'react';
import './EventsScreen.css';

// Import React Components
import EventScreen from './EventScreen';

// Import Firebase settings
import firebase from './firebase.js'
const fdb = firebase.firestore();

/**
 * Events Screen
 */
class EventsScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      category: "All",
      events: [],
      selectedEvent: ""
    }
  }

  //   {
  //   "uid": "7LeKlA8UB0uR37m8OnG5",
  //     "attendees": "[]",
  //       "category": "Personal",
  //         "dateCreated": "2020-05-13T10:04:46-04:00",
  //           "dateExpired": "2020-08-31T24:00:00-04:00",
  //             "dateOccurred": "",
  //               "description": "https://dreamkitapp.squarespace.com/articles/staying-connected-to-the-arts-in-new-haven\nTwo-week coverage of the Virtual International Arts and Ideas Festival",
  //                 "location": "",
  //                   "skills": ["Creativity", "Collaboration", "Professionalism"],
  //                     "title": "Staying Connected to the Arts in New Haven"
  // }

  /* --- Firebase Query Functions --- */

  /**
   * Load events from Firestore once screen loads
   */
  componentDidMount() {
    this.retrieveEvents();
  }

  /**
   * Retrieve events from Firestore
   */
  retrieveEvents() {
    var today = new Date();
    var date = String(today.getFullYear()).padStart(2, '0') + '-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + String(today.getDate()).padStart(2, '0');
    var time = String(today.getHours()).padStart(2, '0') + ":" + String(today.getMinutes()).padStart(2, '0') + ":" + String(today.getSeconds()).padStart(2, '0');
    var currentDatetime = date + 'T' + time + '-04:00';
    // console.log("Current Datetime: " + currentDatetime);

    if (this.state.category === "All") {
      fdb.collection("events")
        .where("dateExpired", ">=", currentDatetime)
        .orderBy("dateExpired")
        .get()
        .then(querySnapshot => {
          this.arrangeEvents(querySnapshot);
        });
      console.log("Grabbing All Events");
    } else {
      fdb.collection("events")
        .where("category", "==", this.state.category)
        .where("dateExpired", ">=", currentDatetime)
        .orderBy("dateExpired")
        .get()
        .then(querySnapshot => {
          this.arrangeEvents(querySnapshot);
        });
      console.log("Grabbing Category Events");
    }
  }

  /**
   * Transform querySnapshot from Firebase into events, arranged in order of presentation
   * querySnapshot: Object returned from Firebase query
   */
  arrangeEvents = (querySnapshot) => {
    const data = querySnapshot.docs.map(doc => Object.assign({ uid: doc.id }, doc.data()));
    // console.log(querySnapshot);
    // console.log(data);

    // Pin DreamKit Hotline Event to the top
    let formattedEvents = data;

    for (let i = 0; i < data.length; i++) {
      if (data[i].uid === "3amGFUDoSwQkjsJh7EC8") {
        formattedEvents.unshift(data[i]);
        formattedEvents.splice(i, 1);
        console.log(formattedEvents);
      }
    }

    this.setState({ events: formattedEvents });
  }

  /* --- Formatting Functions --- */

  formatSubtitle(dateOccured) {
    if (dateOccured === "") {
      return (
        <p className="event-card-subtitle">
          Access This Event Anytime
        </p>
      );
    }
  }

  /* --- State Change Functions --- */

  changeCategory = (newCategory) => {
    this.setState({
      category: newCategory,
    }, () => {
      this.retrieveEvents();
    });
  }

  changeSelectedEvent = (newSelectedEvent) => {
    this.setState({
      selectedEvent: newSelectedEvent,
    });
  }

  /* Render Functions */

  renderEventsScreen() {
    return (
      <div id="events-screen">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xs-12">

              <div id="header">
                <h1 id="dreamkit-title"><span style={{ color: "#3A53FF" }}>Dream</span><span style={{ color: "#FFC836" }}>Kit</span></h1>

                <h2 id="events-screen-title">Activities</h2>
                <br />

                <p>Hi and welcome to DreamKit! Below is a list of activities to help you remain productive during quarantine. These activities include articles, videos, and phone calls with the DreamKit team to help you build professional, educational, and social skills. You can receive $5 gift cards for completing online activities, and build your profile to be shared with employers, landlords, and mentors. Let’s get started!</p>

                <br />

                <p>Please fill out this <a href="https://yalesurvey.ca1.qualtrics.com/jfe/form/SV_eew48DZxmhq4wJv" target="_blank" rel="noopener noreferrer">demographic survey</a> before you start.</p>
                <p>Please read the <a href="https://drive.google.com/file/d/1EEXJ8nwY6xmzCzUfYwep8FVBmTQqHMeK/view?usp=sharing" target="_blank" rel="noopener noreferrer">DreamKit Privacy Policy</a> before proceeding.</p>

                <div id="category-select">
                  <button className={this.state.category === "All" ? 'active-category-btn' : 'category-btn'} onClick={() => this.changeCategory("All")}>All Events</button>
                  <button className={this.state.category === "Professional" ? 'active-category-btn' : 'category-btn'} onClick={() => this.changeCategory("Professional")}>Professional</button>
                  <button className={this.state.category === "Educational" ? 'active-category-btn' : 'category-btn'} onClick={() => this.changeCategory("Educational")}>Educational</button>
                  <button className={this.state.category === "Personal" ? 'active-category-btn' : 'category-btn'} onClick={() => this.changeCategory("Personal")}>Personal</button>
                </div>
              </div>

              <br />

              <div id="event-cards">
                {this.state.events.map((event, index) => (
                  <div key={index} className="event-card" onClick={() => { this.changeSelectedEvent(event); }}>
                    {this.formatSubtitle(event.dateOccurred)}
                    <p className="event-card-title">{event.title}</p>
                    <p className="event-card-category">{event.category}</p>
                  </div>
                ))}
              </div>

            </div>
          </div>
        </div>
      </div >
    )
  }

  renderCurrentScreen = () => {
    if (this.state.selectedEvent === "") {
      return this.renderEventsScreen();
    } else {
      return <EventScreen event={this.state.selectedEvent} changeSelectedEvent={this.changeSelectedEvent} />;
    }
  }

  render() {
    return (
      <div>
        {this.renderCurrentScreen()}
      </div>
    )
  }
}

export default EventsScreen;